import React, { Component } from 'react';
import axios from 'axios'
import styles from './styles.css'

class ContactForm extends Component {
  constructor(props) {
    super(props)

    this.submitForm = this.submitForm.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleError = this.handleError.bind(this)

    this.state = {
      enableAjax: true,
      formName: 'contact',
      recaptchaError: false,
      formError: false,
      subject: 'Matt Patterson - Enquiry Form'
    }
  }

  encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  submitForm(event) {
    if(!this.state.enableAjax) return true

    event.preventDefault()

    const action = '/'

    const recaptchaResponse = event.target.elements['g-recaptcha-response'].value

    if(!this.state.name || !this.state.email || !this.state.message) {
      this.setState({ formError: true })
      this.handleError('Form fields not filled in')
      return true
    } else {
      this.setState({ formError: false })
    }

    if(!recaptchaResponse) {
      this.setState({recaptchaError: true})
      this.handleError('captcha response error')
      return true
    } else {
      this.setState({ recaptchaError: false })
    }

    const data = this.encode({
      'form-name': this.state.formName,
      'subject': this.state.subject,
      'name': this.state.name,
      'email': this.state.email,
      'message': this.state.message,
      'g-recaptcha-response': recaptchaResponse
    })

    const options = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }

    axios.post(action, data, options)
         .then(this.handleSuccess)
         .catch(this.handleError)
  }

  handleSuccess() {
    this.props.onFormSubmission(true)
  }

  handleError(error) {
    console.log(error);
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    const value = target.value

    this.setState({
      [name]: value
    })
  }

  render() {
    return (
      <form name={this.state.formName} className='contact-form' method='POST' data-netlify='true' data-netlify-recaptcha="true" onSubmit={this.submitForm}>
        <input type='hidden' name='form-name' value={this.state.formName} />
        {this.state.formError && <div className='contact-form__input-error'>Please fill in all the fields</div>}
        <div className='contact-form__input'>
          <label htmlFor='name'><super>*</super>Name:</label>
          <input type='text' name='name' value={this.state.name} onChange={this.handleChange} required />
        </div>
        <div className='contact-form__input'>
          <label htmlFor='email'><super>*</super>Email:</label>
          <input type='email' name='email' value={this.state.email} onChange={this.handleChange} required />
        </div>
        <div className='contact-form__input'>
          <label htmlFor='message'><super>*</super>Message:</label>
          <textarea name='message' rows='5' onChange={this.handleChange} required>
            {this.state.message}
          </textarea>
        </div>
        <div className='contact-form__input'>
          {this.state.recaptchaError && <div className='contact-form__input-error'>Please verify you are not a robot</div> }
          <div data-netlify-recaptcha="true"></div>
        </div>
        <div className='contact-form__input'>
          <button className='contact-form__button'>Submit</button>
        </div>
      </form>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js